// extracted by css-extract-rspack-plugin
export default {"exclamationIcon":"_9185d9ac","container":"_786b5243","alertBox":"_e7cd03df"};